// extracted by mini-css-extract-plugin
export default {"text":"Gbza1k","cta":"rR9Riv","email":"du77xL"};